import UserAccessPoint from "./UserAccessPoint";
import MultiUserAccessPoint from "./MultiUserAccessPoint";

import {
  ACCESS_POINT_MODULE,
  ACCESS_POINT_PERMISSION,
  isAccessPointEnable,
} from "./CommonComponents";
export default UserAccessPoint;
export {
  MultiUserAccessPoint,
  ACCESS_POINT_MODULE,
  ACCESS_POINT_PERMISSION,
  isAccessPointEnable,
};
